import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';

import store from './store';
import history from './history';

import App from './App';

ReactDOM.render(
  <Provider store={store}>
    <CssBaseline />
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);
